import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Course } from '../shared/course';
import { APPCONFIG } from "../../config";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-course-list',
  templateUrl: './course-list.component.html'
})
export class CourseListComponent implements OnInit{
  @Input() filter: string;
  @Input() courses: Observable<Course[]>;
  AppConfig: any;


  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-list/course-list.component.ts